/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  // getOrientation,
  // resetOrientation,
  // checkImage,
  getPermissionStatus
} from "../../../utils/methods";
import { saveChallengeData,
  getActivityChallengeById,
  editChallengeLibraryV2 } from "../../../redux/actions/challengeActions";
import {
  getUserCompanyDetails,
  allowChallengeEventForSpouseDependent,
} from "../../../redux/actions/userProfileActions";
// import { imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  Border
} from "../../CreateEvent/style";
import StepsHeading from "../../RecogntionAdmin/corevalues/stepNames"; 
import { Main } from "../../AdminTeamCreation/styles";
import { closeIcon, RecognitionCloseIcon, UploadHDMIcon, AdminRightArrowIcon, AdminLeftArrowIcon } from '../../../utils/icons';
import {CustomInput, SurvivorAverage, SurvivorChallengeSection, TitleContainer} from '../ActivityChallengeCreation/styles';
import moment from 'moment';
import { getCompanyLocation } from "../../../redux/actions";
import { GetTeams, GetCompanyTeamUsers } from '../../../redux/constants/apiConstants';
import { http } from '../../../redux/http';
import { ImageUrl } from "../../../utils/constants";
import { challengeTierPoints } from "../../../../mockData";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import { FormHeading } from "../ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import parse from 'react-html-parser';
import {RadioButtonWrapper, RadioButton} from '../../RecogntionAdmin/styles'
import {CommonButtonPopup} from '../../ReportsV2/styles'
import {CommonButtonBorder} from '../../common/commonStyles'
import { ProfileThemesAll } from '../../../redux/constants/apiConstants';
class EditActivityChallenge extends Component {

  constructor(props) {
    super();
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, createLibrary } = props;
    let ImageName = '';
    if (!_.isEmpty(survivorChallengeData) && (props.activityChallengeById || props.editLibrary)) {
      const Array = survivorChallengeData.image.split('/');
      ImageName = Array[Array.length - 1];
    }
    let updatedTiers = challengeTierPoints;
    this.state = {
      title: _.get(survivorChallengeData, 'title', ''),
      date: _.get(survivorChallengeData, 'date', moment().format('MM/DD/YYYY')),
      endDate: _.get(survivorChallengeData, 'endDate', moment().format('MM/DD/YYYY')),
      description: _.get(survivorChallengeData, 'body', ''),
      imageName: ImageName,
      time: _.get(survivorChallengeData, 'time', moment().format('hh:mm a')),
      endTime: _.get(survivorChallengeData, 'endTime', moment().format('hh:mm a')),
      showDateTimeInput: '',
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: _.get(survivorChallengeData, 'challenge_point', '10'),
      challengeMode: createLibrary ? 'Solo' : _.get(survivorChallengeData, 'challenge_mode', ''),
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', null),
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', null),
      amigosToInvite: [],
      openDateTimePicker: '',
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      companies: _.get(survivorChallengeData, 'companies', []),
      location: [],
      isSpouse: false,
      isDependent: false,
      isEmployee: false,
      challengePoints: updatedTiers,
      challengeLength: 2,
      activityChallengeType: createLibrary ? "Classic challenge" : survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      imageUpdated: 0,
      challengePointKey: _.get(survivorChallengeData, 'challenge_point', '0')+" "+"Points",
      emailOption: {
        "launch_challenge_email": 1,
        "challenge_reminder_email": 1,
        "challenge_complete_email": 1
      },
      companiesPermission: false,
      locationPermission: false,
      selectedOption: 1,
      surveyId: '',
      surveyType: '',
      dailyGoal: _.get(survivorChallengeData, 'daily_goal', null) || null,
      selectedDailyGoalOption: 1,
      is_team_challenge:0,
      teams:[],
      allTeams:[],
      selectedCompany:{
        "id": 1,
        "company_name": "Woliba",
        "show_biometric": 1,
        "spouse_or_dependent": 1,
        "company_start_date": 2016,
        "show_events": 1,
        "show_education": 1,
        "show_employee_directory": 1 },

      step: 1,
      activityArrow: false,
      challengeType: false,
      pointsArrow: false,
      buttonClickScrollTop: false,
      menuIsOpen: true,
      selectedCompanyCheckBox: 0,
      selectedCompanyValue:null,
      selectedCompanyName: null,
      showLocation: 0,
      city_location: [],
      scheduleChallenge: 0,
      buttonStatus: false,
      activityChallengeValue:survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      challengeTypeArrow:false,
      charCount: 0,
      getThemesValue:[],
      selectedTheme: null,
      themeId:_.get(survivorChallengeData, 'theme_month')
    }
   
  }

  componentDidMount() {
    this.getTeams(this.props.companyDetails.id);
    this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    const companiesPermission = getPermissionStatus("Show companies in challenge", this.props.userPermissions);
    const locationPermission = getPermissionStatus("Show locations in challenge", this.props.userPermissions);
    // this.props.getSurveyLibraries();
    // if (companiesPermission) {
  
    // } else {
    this.props.fetchCompanyForUser();
    this.props.allowChallengeEventForSpouseDependent();
    this.setState({
      companies: this.props.userCompany && [this.props.userCompany.id]
    })
    // }
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission,
      activityChallengeValue:this.props.survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : this.props.survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge'
    })
    document.addEventListener('mousedown', this.handleClick);

    if(this.props.role != "ADMIN"){
      this.getTeams(this.props.companyDetails.id);
    }else{
      this.onCompanySelect('selectedCompany', this.state.selectedCompany, this.state.selectedCompany['key'])
    }
    this.getThemes()
  }

  componentDidUpdate(prevProps) {
    if (this.props.survivorChallengeData !== prevProps.survivorChallengeData || prevProps.surveyLibraries !== this.props.surveyLibraries) {
      this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    }
    if (!this.state.companiesPermission && this.props.userCompany !== prevProps.userCompany) {
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id]
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  getThemes = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${ProfileThemesAll}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        let data = [{ month_number: null, theme_text: 'None', month:"" }];
        this.setState({
          // getThemesValue:res.all_themes
          getThemesValue: data.concat(res.all_themes)
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  onCompanySelect = async(name, value, key = '') => {
    const { challengePointKey } = this.state;
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetCompanyTeamUsers}/${value.id}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res,
          [name]: value,
          challengePointKey: key != '' ? key : challengePointKey,
          companies:[value.id]
        })
      }
    }catch(error){
      toast.error(error.message);
    }
    
  };

  fillProps = () => {
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, surveyLibraries } = this.props;
    const Array = survivorChallengeData.image.split('/');
    let ImageName = Array[Array.length - 1];
    let tierPointsIndex = this.state.challengePoints.findIndex((data) => data.value == _.get(survivorChallengeData, 'challenge_point', '0'));
    let surveyIndex = surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries.findIndex((data) => data.id === survivorChallengeData.survey_id) : -1;
    const plainText = _.get(survivorChallengeData, 'body')
      ?.replace(/<[^>]*>/g, '')
      ?.replace(/&nbsp;/g, ' ')
      ?.trim();
    this.setState({
      title: _.get(survivorChallengeData, 'title'),
      date: _.get(survivorChallengeData, 'date', moment().format('MM/DD/YYYY')),
      endDate: _.get(survivorChallengeData, 'endDate', moment().format('MM/DD/YYYY')),
      description: _.get(survivorChallengeData, 'body'),
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: tierPointsIndex == -1 ? 0 : _.get(survivorChallengeData, 'challenge_point', '12'),
      challengeMode: _.get(survivorChallengeData, 'challenge_mode') || 'Solo',
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', null) || null,
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', null) || null,
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      imageName: ImageName,
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      activityChallengeType: survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      challengePointKey: this.state.challengePointValue+" "+"Points",
      surveyId: survivorChallengeData.survey_id,
      surveyType: surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries[surveyIndex === -1 ? 0 : surveyIndex].survey_name : '',
      selectedOption: surveyIndex === -1 ? 1 : 0,
      dailyGoal: _.get(survivorChallengeData, 'daily_goal', null) || null,
      charCount: plainText?.length,
      themeId:_.get(survivorChallengeData, 'theme_month'),
      activityChallengeValue:survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge'
    })
  }

  activityChallengeTypes = [
    {"key": "Classic challenge", "value": 'Classic challenge'},
    {"key": "Survivor challenge", "value": 'Survivor challenge'},
    {"key": "Charity Challenge", "value": 'Group Challenge'}
  ]

  activityTypesItems= [
    {"key": "Total Steps", "value": 'Total Steps', 'label':"Steps"},
    {"key": "Total Distance", "value": 'Total Distance', 'label':"Distance"},
    {"key": "Total Calories", "value": 'Total Calories', 'label':"Calories"}
  ]

  groupActivityTypesItems= [
    {"key": "Total Group Steps", "value": 'Total Group Steps', 'label':"Total group steps"},
    {"key": "Total Group Distance", "value": 'Total Group Distance', 'label':"Total group distance"},
    {"key": "Total Group Calories", "value": 'Total Group Calories', 'label':"Total group Calories"}
  ]

  stepsHeadingEvent = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2
    },
    {
      name: 'Edit Challenge',
      showArrow: false,
      number: 3
    }
  ]; 
    
  renderHeading = () => {
    const { survivorChallengeData } = this.props;
    const challengeType= survivorChallengeData.challenge_type=="survivor"?"Survivor Challenge":survivorChallengeData.challenge_type=="group"&&survivorChallengeData.is_team_challenge?this.props.t("Team Challenge"):survivorChallengeData.challenge_type=="new_group"?this.props.t("Charity Challenge"):this.props.t("Classic Challenge")
    return(
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={() => window.history.back() }>
          <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        {this.props.t("Edit ")} {this.props.t(challengeType)}
      </FormHeading>
    )};

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };


  onChangeDescription = (e) => {
    const newContent = e.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };


  // onChange = (e) => {
  //   let file = e.target.files[0];
  //   if (checkImage(e.target.files)) {
  //     if ((file?.size / 1000000) <= 20) {
  //       let reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       const array = document.getElementById('create-challenge-file').value.split("\\");
  //       reader.onloadend = () => {
  //         this.setState({
  //           imgSrc: reader.result,
  //           imageName: array[array.length - 1],
  //           editImage: reader.result
  //         });
  //         getOrientation(file, (or) => {
  //           resetOrientation([reader.result], or, (baseImage) => {
  //             this.setState({
  //               imgSrc: baseImage,
  //               editImage: baseImage,
  //               imageUpdated: this.props.editLibrary ? 1 : 0
  //             });
  //           });
  //         });
  //       };
  //     } else {
  //       toast.error(this.props.t('Please select image file less than 20MB'));
  //       document.getElementById('create-challenge-file').value = '';
  //     }
  //   } else {
  //     toast.error(imageErrorMessage);
  //     document.getElementById('create-challenge-file').value = '';
  //   }
  // };

  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }

  onImageChange = (imageSrc) => {
    this.setState({
      imgSrc: imageSrc,
    });
  };

  removePhoto = () => {
    this.setState({ imgSrc: null });
  };
 

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      imgSrc,
      charCount
    } = this.state;
    const { t } = this.props;
    const maxLength = 3000;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeLibraryEdit"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the challenge")}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter challenge title")}
                    name="title"
                    value={title}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/30 | C</div>
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Challenge image")}<span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />        
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("About the challenge")}</StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      config={{
                        placeholder: 'Enter challenge description',
                        contentStyle: 'body { color: #184A61 !important; }'
                      }}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        const modelDocument = editor.model.document;

                        modelDocument.on('change:data', () => {
                          const data = editor.getData();
                          const plainText = data
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          const count = plainText.length;

                          if (count > maxLength) {
                            editor.execute('undo');
                            return;
                          }

                          this.setState({
                            description: data,
                            charCount: count,
                            disableButton: false,
                          });
                        });
                      }}
                    />

                  </EditorContainer>

                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  onSelect = (name) => {
    this.setState({
      activityChallengeType: name.value,
      survivorChallenge: name.value === "Survivor challenge",
      groupChallenge: name.value === "Group Challenge",
      activityType: name.value === "Group Challenge" ? "Total Group Steps" : "Total Steps",
      challengePointKey: this.state.challengePointKey,
      activityChallengeValue: name.key,
      selectedChallengeType:name.value,});
  };


  onSelectType = (name) => {
    this.setState({
      activityType: name.value,
    });
  };


  onSelectCompany = (name, value, key ) => {
    this.setState({
      [name]: value,
      selectedCompanyName: key
    });
    this.props.getCompanyLocation(value);
    this.getTeams(value);
  };

  isNumberKey = (evt) => {
    let charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) evt.preventDefault();
  };

  toggleRadioGoalButton = (value) => {
    this.setState({ showLocation: parseInt(value,10) }, () => { });
  };

  handleSelectChallengeType = (name) => {
    this.setState({
      activityChallengeType: name.value,
      survivorChallenge: name.value === "Survivor challenge",
      groupChallenge: name.value === "Group Challenge",
      activityType: name.value === "Group Challenge" ? "Total Group Steps" : "Total Steps",
      challengePointKey: this.state.challengePointKey,
      activityChallengeValue: name.key,
      selectedChallengeType:name.value,
    })
   
  };

  onSelectThemeType = (selectedItem) => {
    this.setState({
      // selectedTheme: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      selectedTheme: selectedItem.month,
      themeId: selectedItem.month_number,
    });
  };

  stepTwoForm = () => {
    const {
      step,
      groupChallenge,
      activityType,
      survivorChallenge,
      survivorAverage,
      weeklyIncrement,
      challengePoints,
      pointsArrow,
      challengePointKey,
      challengePointValue,
      activityChallengeValue,
      selectedTheme,
      getThemesValue,
      challengeTypeArrow,
      themeId
    } = this.state;
    const { t } = this.props;
    const activityTypes = groupChallenge ? this.groupActivityTypesItems : this.activityTypesItems;

    // const selectedThemeText = getThemesValue?.find((data) => data.month_number === themeId)?.theme_text;
    const selectedThemeText = getThemesValue?.find((data) => data.month_number === themeId);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challengeLibraryEdit" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">

                <TitleContainer widthValue="70%" height="auto" padding="15px 0px 0px 0px">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge types")}
                    // isRequired={true}
                    placeholder={t("Select type")}
                    // title={activityChallengeValue ? t(activityChallengeValue) : t("Select challenge type")}
                    title={activityChallengeValue? activityChallengeValue?.includes("Group") ? activityChallengeValue?.replace("Group", "Charity") : activityChallengeValue:"Select challenge type"}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ challengeTypeArrow: !challengeTypeArrow })}
                    data={this.activityChallengeTypes}
                    onSelect={this.onSelect}
                    active={activityChallengeValue}
                    onSelectParameter={["value", "key"]}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    t={t}
                    dropIcon={true}
                    fontSize={"14px"}
                  />
                  <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                </TitleContainer>
                <TitleContainer widthValue="70%" height="auto" padding="0px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">{this.props.t("Type of activity")}</StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      {activityTypes?.map((data,index)=>(
                        <div className="RadioButtonContainer" key={index}>
                          <RadioButton
                            type={"radio"}
                            checked={activityType === data.value}
                            onChange={() => this.onSelectType(data)}
                            id={data.label+1}
                            name="activityType"
                            value={data.key}
                          />
                          <div className="label">{data?.label}</div>              
                        </div>))}
                    </RadioButtonWrapper>
                  </div>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                </TitleContainer>  
                {(groupChallenge) &&
                <SurvivorAverage width="100%" isMargin={"0"} marginb="0" isHeight={"50px"}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Group goal")}{<span className="imp">*</span>}</StyledLabel>
                  <CustomInput
                    height={"48px"}
                    isRadius={"4px"}
                    isBorder={"1px solid #BDBDBD"}
                    isBgColor={"white"}
                    type='number'
                    name='survivorAverage'
                    onChange={this.onChangeInput}
                    value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                    pattern='[0-9]*'
                    min="0"
                    onKeyPress={(e) => this.isNumberKey(e)}
                    placeholder={activityType==="Total Steps"?"Enter E.g. 500 Steps":activityType==="Total Calories"?this.props.t("Enter E.g. 30 Calories"):this.props.t("Enter E.g. 25 Miles")}
                  />
                </SurvivorAverage>}
                <SurvivorChallengeSection>
                  {(survivorChallenge) && <SurvivorAverage display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                    <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{groupChallenge ? t('Team Goal') : t('Week one Goal')}{<span className="imp">*</span>}</StyledLabel>
                    <CustomInput
                      width="100%"
                      height={"48px"}
                      isFont={"rubik"}
                      isRadius={"4px"}
                      isBorder={"1px solid #BDBDBD"}
                      isBgColor={"white"}
                      type='number'
                      name='survivorAverage'
                      onChange={this.onChangeInput}
                      value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                      pattern='[0-9]*'
                      min="0"
                      onKeyPress={(e) => this.isNumberKey(e)}
                      placeholder={activityType==="Total Distance"?this.props.t("Enter E.g. 25,000 Miles"):activityType==="Total Calories"?this.props.t("Enter E.g. 300 Calories"):this.props.t("Enter E.g. 5000 Steps")}
                    />
                    <div className="char-count">
                      <div className="count">{activityType.includes("Steps")?"(Example: 5000 steps)":activityType.includes("Calories")?"(Example: 5000 calories)":"(Example: 50 miles)"}</div>
                      <div className="count"></div>
                    </div>
                  </SurvivorAverage>}
                  {survivorChallenge &&
              <SurvivorAverage  display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Weekly increment")}{<span className="imp">*</span>}</StyledLabel>
                <CustomInput
                  width="100%"
                  height={"48px"}
                  isFont={"rubik"}
                  isRadius={"4px"}
                  isBorder={"1px solid #BDBDBD"}
                  isBgColor={"white"}
                  type='number'
                  name="weeklyIncrement"
                  value={parseFloat(weeklyIncrement)}
                  onChange={this.onChangeInput}
                  pattern='[0-9]*'
                  min="0"
                  onKeyPress={(e) => this.isNumberKey(e)}
                  placeholder={activityType==="Total Steps"?"Enter E.g. 500 Steps":activityType==="Total Calories"?"Enter E.g. 30 Calories":"Enter E.g. 25 Miles"}
                />
              </SurvivorAverage>}
                </SurvivorChallengeSection>
                {survivorChallenge || groupChallenge ? <Border style={{background:'#EFEFEF',margin:'20px 0px 5px 0px'}}/>: null}

                <TitleContainer widthValue="70%" height="auto" padding="0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge point value")}
                    // isRequired={true}
                    dropdownOpen={pointsArrow}
                    placeholder={t("Select point value")}
                    title={challengePointKey=="0 Points"?"No Points":challengePointKey?t(challengePointKey) : t("Select point value")}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ pointsArrow: !pointsArrow })}
                    data={challengePoints}
                    onSelect={this.onSelectPoints}
                    active={challengePointValue}
                    onSelectParameter={["value", "key"]}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    t={t}
                    fontSize={"14px"}
                    dropIcon={true}
                  />
                </TitleContainer>

                <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px', display:"flex"}}/>
                <TitleContainer widthValue="70%" height="auto" padding="0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge month")}
                    isRequired={false} 
                    dropdownOpen={this.state.so}
                    placeholder={t("Select month")}
                    title={selectedTheme ? selectedTheme : selectedThemeText ? selectedThemeText?.month : "Select Month"}
                    id="dropdown-survey"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={getThemesValue}
                    onSelect={this.onSelectThemeType}
                    active={themeId}
                    onSelectParameter={["theme_text", "month_number", "month"]}
                    itemValue={true}
                    valueIndex={2}
                    labelMargin={"0px"}
                    t={t}
                    dropIcon={true}
                    fontSize={"14px"}
                    showWrapText={0}
                  />
                </TitleContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (name, value) => {
    this.setState({ [name]: value }, () => { });
    if(name=="selectedDailyGoalOption"&&value===1){
      this.setState({
        dailyGoal:null
      })
    }
  };

  dateRadioButton = (name, value ) => {
    this.setState({ [name]: value });
    if(value===1){
      this.setState({
        date: "",
        endDate:''
      })
    }
    if(value===0){
      this.setState({
        date: moment().format('MM/DD/YYYY'),
        endDate: moment().format('MM/DD/YYYY')
      })
    }
  };

  onSelectSurveyType = (name) => {
    this.setState({
      surveyType: name.survey_name,
      surveyId: name.id
    });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    let invitedCompanies = [];
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      invitedCompanies = [];
    } else {
      allCompanies && allCompanies.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies
    })
  };

  onCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies
    })
  };

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { city_location } = this.state;
    if (city_location.length == locationDetails.length) {
      this.setState({
        city_location: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        city_location: arr,
      });
    }
  };

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    if (city_location.includes(id)) {
      let index = city_location.findIndex((item) => item === id);
      if (index > -1) {
        city_location.splice(index, 1);
      }
    } else {
      city_location.push(id);
    }
    this.setState({
      city_location: city_location,
    });
  };

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  selectAllTeams = (e) => {
    e.preventDefault();
    let invitedTeams = [];
    const { allTeams } = this.state;
    if (this.state.teams.length === allTeams.length) {
      invitedTeams = [];
    } else {
      allTeams.map((company) => {
        invitedTeams.push(company.id);
      });
    }
    this.setState({
      teams: invitedTeams
    })
  };

  onTeamsCheckboxChange = (element) => {
    const { teams } = this.state;
    if (teams.includes(element)) {
      let index = teams.findIndex((item) => item === element);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(element);
    }
    this.setState({
      teams: teams
    })
  };

  stepThreeForm = () => {
    const {
      step,
      selectedOption,
      surveyType,
    } = this.state;
    const {surveyLibraries, t} = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} padding="20px 20px 265px 20px" type="challengeLibraryEdit" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("Would you like to add the survey")} ?
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton( "selectedOption",0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"Yes"}</div>              
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton( "selectedOption",1)}
                        value={1}
                        id="2"
                      />
                      <div className="label">{"No"}</div>              
                    </div>
                  </RadioButtonWrapper>
                </div>
                {selectedOption === 0 ?<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>:null}
                {selectedOption===0?
                  <TitleContainer widthValue="70%" height="auto" padding="0">
                    <CommonDropdown
                      tileContainerStyle={{ width: "100%", padding: "0px 0px 20px 0px" }}
                      labelText={t("List of surveys")}
                      isRequired={true}
                      placeholder={t("Select survey")}
                      title={surveyType ? t(surveyType) : t("Select survey")}
                      id="dropdown-recurring"
                      data={surveyLibraries}
                      onSelect={this.onSelectSurveyType}
                      onSelectParameter={["survey_name", "id"]}
                      active={surveyType}
                      itemValue={true}
                      displayValue={true}
                      onClick={() => this.setState({ surveyArrow: !this.state.surveyArrow })}
                      valueIndex={0}
                      t={t}
                      selectedClassCategory={surveyType}
                      isChallengeWellness={false}
                      createEventUI={false}
                      labelMargin={"0px"}
                      dropIcon={true}
                      fontSize={"14px"}
                    />
                  </TitleContainer>:null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  setDatePickerWrapper = (node) => {
    this.datePickerWrapper = node;
  };

  changeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === 'date') {
      this.setState({
        date: moment(e._d).format('MM/DD/YYYY'),
        time: moment(e._d).format('hh:mm a'),
        endDate: moment(e._d).format('MM/DD/YYYY'),
        endTime: '11:59 pm',
        openDateTimePicker: '',
      });
    } else if (stateName.includes('ate')) {
      if(stateName === 'date'){
        this.setState({
          openDateTimePicker: '',
          [stateName]: moment(e._d).format('MM/DD/YYYY'),
          endDate:moment(e._d).format('MM/DD/YYYY'),
        });
      }else {
        this.setState({
          openDateTimePicker: '',
          [stateName]: moment(e._d).format('MM/DD/YYYY'),
        });

      }
    } else {
      this.setState({
        [stateName]: moment(e._d).format('hh:mm a'),
        openDateTimePicker: stateName
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {
      this.setState({
        openDateTimePicker: ''
      });
    } else {
      this.setState({
        openDateTimePicker: value
      });
    }
  };

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  }

  checkBase64(image) {
    if (image) {
      if (image.includes('base64')) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  onSubmit = () => {
    // e.preventDefault();
    const { title, date, description, imgSrc, endDate, activityType, challengePointValue, challengeMode, weeklyIncrement,
      survivorAverage, imageName, companies, location, isSpouse, isDependent, isEmployee, challengeLength, survivorChallenge, groupChallenge, /*imageUpdated,*/ emailOption, locationPermission, surveyId, selectedOption, dailyGoal, selectedDailyGoalOption, is_team_challenge, teams, themeId } = this.state;
    const {  saveChallengeData, companyDetails, createLibrary, activityChallengeById, editLibrary, editChallengeLibrary, history } = this.props;
    let survivorEndDate = moment(moment(date).add((challengeLength * 7) - 1, 'days')._d).format('MM/DD/YYYY');
    const challengeType = survivorChallenge ? 'survivor' : groupChallenge ? 'new_group' : 'group';
    this.setState({ buttonStatus: true });
    const challenge = {
      title,
      companies: companies,
      body: description,
      image: imgSrc,
      event_type: groupChallenge ? activityType === 'Total Group Steps' ? 'Total Steps' : activityType === 'Total Group Calories' ? 'Total Calories' : 'Total Distance' : activityType,
      end_date: createLibrary || editLibrary ? null : (survivorChallenge || groupChallenge) ? moment(survivorEndDate).format('YYYY-MM-DD') + ' ' + moment('11:59:59 PM', "hh:mm:ss a").format("HH:mm:ss") : moment(endDate).format('YYYY-MM-DD') + ' ' + moment('11:59:59 PM', "hh:mm:ss a").format("HH:mm:ss"),
      start_date: createLibrary || editLibrary ? null : moment(date).format('YYYY-MM-DD') + ' ' + moment('12:00:00 AM', "hh:mm:ss a").format("HH:mm:ss"),
      survivor_average: survivorAverage,
      weekly_increment: survivorChallenge ? weeklyIncrement : null,
      challenge_point: challengePointValue,
      challenge_mode: survivorChallenge ? challengeMode : '',
      challenge_type: challengeType,
      isSurvivorChallenge: survivorChallenge,
      isGroupChallenge: groupChallenge,
      ...emailOption,
      survey_id: selectedOption === 1 ? null : surveyId,
      daily_goal: selectedDailyGoalOption === 1 ? null : dailyGoal,
      is_team_challenge:is_team_challenge, 
      teams:teams,
      theme_month: themeId
    };
    // activityChallengeById ? challenge.convert_image = !this.checkBase64(imgSrc) : null;
    if(activityChallengeById){
      challenge.convert_image = !this.checkBase64(imgSrc)
    }
    if (editLibrary) {
      challenge.id = this.props.survivorChallengeData['id'];
      challenge.imageUpdated = this.checkBase64(imgSrc) ? 1 : 0;
    }
    if (locationPermission) {
      challenge.company_city_states = location;
      challenge.challenge_for_spouse = isSpouse ? 1 : 0;
      challenge.challenge_for_dependent = isDependent ? 1 : 0
      if (this.props.locationDetails && this.props.locationDetails.length > 0) {
        if(location.length > 0){
          challenge.is_for_employee = 1
        }
        else{
          challenge.is_for_employee = 0
        }
      }
      else {
        if (companyDetails['spouse_or_dependent']) {
          challenge.is_for_employee = isEmployee ? 1 : 0
        }
        else {
          challenge.is_for_employee = 1
        }
      }
    }

    saveChallengeData({ ...challenge, imageName });
    editChallengeLibrary(challenge, history.location.pathname.includes("/company/challenges/")?`/company/challenges/categories/${challengeType}`:`/challenges/categories/${challengeType}`);
  };


  DropdownIndicator = () => (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C12 10.3585 11.8559 10.7169 11.5684 10.9901L2.51663 19.5897C1.94083 20.1368 1.00725 20.1368 0.431681 19.5897C-0.143894 19.0429 -0.143894 18.1561 0.431681 17.609L8.44122 10L0.43196 2.39098C-0.143614 1.84394 -0.143614 0.957264 0.43196 0.410484C1.00753 -0.136826 1.94111 -0.136826 2.51691 0.410484L11.5687 9.00992C11.8563 9.28333 12 9.64172 12 10Z"
        fill="#0D4270"
      />
    </svg>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true, buttonStatus: false });
  };

  onSelectPoint = (name, value, key ) => {
    this.setState({
      [name]: value,
      challengePointKey: key
    });
  };


  onSelectPoints = (name) => {
    this.setState({
      [name]: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
    });
  };

  

  render() {
    const { step, buttonStatus, title, imgSrc, description, activityType, activityChallengeType, survivorChallenge, groupChallenge, weeklyIncrement, survivorAverage, selectedOption, surveyType} = this.state;
    return (
      <React.Fragment>
        {step === 1?this.stepOneForm(): step === 2? this.stepTwoForm(): step === 3 && this.stepThreeForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description} onClick={!title||!imgSrc|| !description?null: () => this.updateStep(2)}>
                Next
                {!title||!imgSrc|| !description ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {AdminLeftArrowIcon("#F37A65")}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage) } onClick={!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage) ?null: () => this.updateStep(3)}>
                Next
                {!activityType || !activityChallengeType || (survivorChallenge && (!weeklyIncrement || !survivorAverage)) || (groupChallenge && !survivorAverage)  ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          step === 3 && (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(2)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={selectedOption===0&&!surveyType||buttonStatus} onClick={!buttonStatus? () => this.onSubmit():null}>
                  {this.props.t("Save Challenge")}
                  {selectedOption===0&&!surveyType||buttonStatus ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )
        )}
      </React.Fragment>
    );
  }
}

EditActivityChallenge.propTypes = {
  isSurvivorChallenge: PropTypes.bool.isRequired,
  createChallenge: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onHide: PropTypes.func,
  MandatoryFields: PropTypes.array.isRequired,
  survivorChallengeData: PropTypes.object,
  saveChallengeData: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchAllCompanies: PropTypes.func.isRequired,
  role: PropTypes.string,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  isGroupChallenge: PropTypes.bool,
  activityChallengeById: PropTypes.bool,
  createLibrary: PropTypes.bool,
  editChallengeLibrary: PropTypes.func,
  editLibrary: PropTypes.bool,
  userPermissions: PropTypes.array,
  surveyLibraries: PropTypes.array,
  getSurveyLibraries: PropTypes.func,
  t: PropTypes.func,
  fetchCompanyTeamUsers:PropTypes.func,
  challengeDetails: PropTypes.array,
  getChallengeDetails: PropTypes.func,
  getCompanyLocation: PropTypes.func
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  userPermissions: state.profileData.userPermissions,
  surveyLibraries: state.surveys.surveyLibraries,
  challengeDetails: state.challenges.activityDetailsById
});

const mapDispatchToProps = (dispatch) => ({
  saveChallengeData: (data) => dispatch(saveChallengeData(data)),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () => dispatch(allowChallengeEventForSpouseDependent),
  editChallengeLibrary: (challenge, path) => dispatch(editChallengeLibraryV2(challenge, path)),
  fetchCompanyTeamUsers: (companyId) => dispatch(fetchCompanyTeamUsers(companyId)),
  getChallengeDetails: (id) => dispatch(getActivityChallengeById(id)),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditActivityChallenge));
